import { render, staticRenderFns } from "./DrawingCanvas.vue?vue&type=template&id=a174af26&scoped=true&"
import script from "./DrawingCanvas.vue?vue&type=script&lang=ts&"
export * from "./DrawingCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./DrawingCanvas.vue?vue&type=style&index=0&id=a174af26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a174af26",
  null
  
)

export default component.exports